module.exports = __webpack_public_path__ + "img/screenshot2.cd2beab2.png";